// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"TableList_tableWrapper__3Ir4c","logContent":"TableList_logContent__3hq9g"};